module.exports = __webpack_public_path__ + "img/title1.0924c9de.png";